export default __webpack_public_path__ + "static/media/password_icon.06411510.png";